import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/switchMap';

@Injectable()
export class SearchService {

  baseUrl: string = '/buses/search';
  queryUrl: string = '?q=';

  httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json', 'ignoreLoadingBar': ''})
  };

  constructor(private http: HttpClient) { }

  search(terms: Observable<string>, baseUrl=null, queryUrl=null) {
    if(baseUrl) this.baseUrl = baseUrl;
    if(queryUrl) this.queryUrl = queryUrl;
    return terms.debounceTime(400)
      .distinctUntilChanged()
      .switchMap(term => this.searchEntries(term));
  }

  searchEntries(term) {
    console.log(this.baseUrl + this.queryUrl + term);
    return this.http.get(this.baseUrl + this.queryUrl + term, this.httpOptions);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/search.service.ts